/** Documentos da plataforma exibidos em todos os rodapés das campanhas padrão. */
export const SORTEIOS_SITE_ORIGIN = 'https://sorteios.com.br'

export const PUBLIC_LEGAL_LINKS = {
  terms: `${SORTEIOS_SITE_ORIGIN}/termos-de-uso/`,
  privacy: `${SORTEIOS_SITE_ORIGIN}/politica-de-privacidade/`,
} as const
